export function CompassMark() {
  return (
    <span className="compass-mark" aria-hidden="true">
      <span>✦</span>
    </span>
  );
}
